import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import './App.scss';
import { IS_BO } from './global/config/constants';
import { setAxiosDefaults } from './global/helpers/actions';
import { llAllocationsBO, llRequestFormBO, llRequestsBO, llSettingsBO, llWelcomeBO } from './global/helpers/lazy';
import { XsSnackbar, XsLoading, XsFooter } from './global/ui';
import GlobalStore from './global/stores/GlobalStore';
import LoginContainer from './modules/common/login/LoginContainer';
import Register from './modules/common/login/Register';
import RegisterFinishContainer from './modules/common/login/RegisterFinishContainer';
import ResetPasswordContainer from './modules/common/login/ResetPasswordContainer';
import ConfirmRegistrationDialog from './modules/common/login/ConfirmRegistrationDialog';
import Requests from './modules/common/requests/Requests';
import MainContainer from './modules/common/main/MainContainer';
import MaintenanceContainer from './modules/common/maintenance/MaintenanceContainer';
import WaitingList from './modules/common/waiting/WaitingList';
import CallsList from './modules/common/calls/CallsList';
import CallDetail from './modules/common/calls/CallDetail';
import RequestForm from './modules/common/requestForm/RequestForm';

setAxiosDefaults();

// ─── Spoločné (auth) routy — common/login ───────────────────────────────────
// Pozn.: pole (nie fragment) — React Router v5 <Switch> nerekurzuje do fragmentov.
const sharedRoutes = () => [
  <Route key='login' exact path='/login'>
    <main className='main_container'>
      <LoginContainer />
    </main>
  </Route>,
  <Route key='maintenance' exact path='/maintenance'>
    <main className='main_container'>
      <MaintenanceContainer />
    </main>
  </Route>,
  <Route key='register' exact path='/register'>
    <main className='main_container'>
      <Register />
    </main>
  </Route>,
  <Route key='registerFinish' exact path='/registerFinish'>
    <main className='main_container'>
      <RegisterFinishContainer />
    </main>
  </Route>,
  <Route key='passwordResetFinish' exact path='/passwordResetFinish'>
    <main className='main_container'>
      <ResetPasswordContainer />
    </main>
  </Route>
];

// ─── BackOffice routy — dynamicky doťahované (lazy) ──────────────────────────
function BoRoutes() {
  const RequestsModule = llRequestsBO();
  const RequestFormModule = llRequestFormBO();
  const AllocationsModule = llAllocationsBO();
  const SettingsModule = llSettingsBO();
  const WelcomeModule = llWelcomeBO();

  return (
    <Switch>
      {sharedRoutes()}
      <Route exact path='/welcome'>
        <main className='main_container'>
          <WelcomeModule component='WelcomeContainer' />
        </main>
      </Route>
      <Route exact path='/allocations'>
        <main className='main_container'>
          <AllocationsModule component='AllocationsContainer' />
        </main>
      </Route>
      <Route exact path='/settings'>
        <main className='main_container'>
          <SettingsModule component='SettingsContainer' />
        </main>
      </Route>
      <Route exact path='/request'>
        <main className='main_container'>
          <RequestFormModule component='RequestFormContainer' />
        </main>
      </Route>
      <Route path={['/', '/requests']}>
        <main className='main_container'>
          <RequestsModule component='RequestsContainer' />
        </main>
      </Route>
    </Switch>
  );
}

// ─── FrontOffice routy — common moduly ───────────────────────────────────────
function FoRoutes() {
  return (
    <Switch>
      {sharedRoutes()}
      <Route exact path='/'>
        <main className='main_container'>
          <MainContainer />
        </main>
      </Route>
      <Route exact path='/waiting'>
        <main className='main_container'>
          <WaitingList />
        </main>
      </Route>
      <Route exact path='/calls'>
        <main className='main_container'>
          <CallsList />
        </main>
      </Route>
      <Route exact path='/call'>
        <main className='main_container'>
          <CallDetail />
        </main>
      </Route>
      <Route exact path='/requests'>
        <main className='main_container'>
          <Requests />
        </main>
      </Route>
      <Route exact path='/request'>
        <main className='main_container'>
          <RequestForm />
        </main>
      </Route>
    </Switch>
  );
}

function App() {
  return (
    <div id='app'>
      <Router>{IS_BO ? <BoRoutes /> : <FoRoutes />}</Router>
      <XsFooter />
      <XsSnackbar />
      {GlobalStore.isLoading && <XsLoading overlay message={GlobalStore.loadingMessage} />}
      {GlobalStore.confirmRegistrationDialogOpened && <ConfirmRegistrationDialog />}
    </div>
  );
}

export default observer(App);
